export default __webpack_public_path__ + "static/media/hero-image-3@2x.25577d8d.png";